import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cc-empty-list-state',
  templateUrl: './empty-list-state.component.html',
  styleUrls: ['./empty-list-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyListStateComponent {
  @Input() hasItemsButNoProperty = null;
  @Output() startAddItem = new EventEmitter<void>();
  @Output() addProperty = new EventEmitter<void>();
  @Output() importCSV = new EventEmitter<void>();

  addAction(): void {
    if (this.hasItemsButNoProperty) {
      this.addProperty.emit();
    } else {
      this.startAddItem.emit();
    }
  }

  importAction(): void {
    this.importCSV.emit();
  }

  get helpLink(): string {
    return this.hasItemsButNoProperty
      ? 'https://intercom.help/dashpivot/en/articles/5229580-list-properties'
      : 'https://intercom.help/dashpivot/en/articles/2563225-lists-overview';
  }

  get helpText(): string {
    return this.hasItemsButNoProperty
      ? 'Properties are the values contained within your list items.'
      : 'List items are the values contained within your list.';
  }

  get imageURL(): string {
    return this.hasItemsButNoProperty
      ? '/assets/images/list/empty-properties.svg'
      : '/assets/images/list/empty-list.svg';
  }

  get pluralisedEntity(): string {
    return this.hasItemsButNoProperty ? 'properties' : 'items';
  }
}
